import { FormEvent, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { adminApi, ApiError } from "../lib/api";
import { useAdminAuth } from "../lib/auth";

type AuthMode = "login" | "register";

export function AuthPage() {
  const navigate = useNavigate();
  const auth = useAdminAuth();
  const [mode, setMode] = useState<AuthMode>("login");
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("admin");
  const [inviteKey, setInviteKey] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (auth.token) {
    return <Navigate to="/accounts" replace />;
  }

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError(null);
    setIsSubmitting(true);

    try {
      const result =
        mode === "login"
          ? await adminApi.login({ username, password })
          : await adminApi.register({ username, password, inviteKey });

      auth.login(result.token, result.admin);
      navigate("/accounts", { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Не удалось войти в админку");
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="admin-shell flex min-h-screen items-center justify-center p-4">
      <section className="panel w-full max-w-md p-5">
        <div className="mb-5">
          <p className="text-sm font-medium text-primary">WhatsAI Admin</p>
          <h1 className="mt-1 text-2xl font-semibold">Вход в админку</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Отдельная авторизация для просмотра аккаунтов, агентов и логов пайплайна.
          </p>
        </div>

        <div className="mb-4 grid grid-cols-2 rounded-lg bg-muted p-1">
          <button
            className={`rounded-md px-3 py-2 text-sm font-medium ${mode === "login" ? "bg-white shadow-sm" : "text-muted-foreground"}`}
            type="button"
            onClick={() => setMode("login")}
          >
            Вход
          </button>
          <button
            className={`rounded-md px-3 py-2 text-sm font-medium ${mode === "register" ? "bg-white shadow-sm" : "text-muted-foreground"}`}
            type="button"
            onClick={() => setMode("register")}
          >
            Регистрация
          </button>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <label className="block space-y-1.5">
            <span className="text-sm font-medium">Логин</span>
            <input
              className="control"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="username"
              required
            />
          </label>

          <label className="block space-y-1.5">
            <span className="text-sm font-medium">Пароль</span>
            <input
              className="control"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete={mode === "login" ? "current-password" : "new-password"}
              required
            />
          </label>

          {mode === "register" ? (
            <label className="block space-y-1.5">
              <span className="text-sm font-medium">Invite key</span>
              <input
                className="control"
                value={inviteKey}
                onChange={(event) => setInviteKey(event.target.value)}
                required
              />
            </label>
          ) : null}

          {error ? <p className="text-sm text-danger">{error}</p> : null}

          <button
            className="flex h-10 w-full items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground disabled:opacity-60"
            disabled={isSubmitting}
            type="submit"
          >
            {isSubmitting ? "Проверяем..." : mode === "login" ? "Войти" : "Зарегистрироваться"}
          </button>
        </form>
      </section>
    </div>
  );
}
